import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import { Paper, Button, Grid, TextField, } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import EditIcon from '@material-ui/icons/Edit';
import { getPermissionKey } from "..";
import { checkApiStatus, checkPermission, } from '../../utils_v2';
import { globalGetService, globalPostService, globalPutService } from '../../../globalServices';
import { PageLoader, STableLoader } from '../../shared_elements';
import { assetTypeValues, } from '../../../constants';
import { trackActivity } from '../../../utils/mixpanel';
import { usePageTitleOffset } from '../../elements/CollapsibleSideNav';
const TAMiscellaneous = ({ params, assetInfoData }) => {
  const navTitleOffset = usePageTitleOffset('techSpecsNavCollapsed');
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [isEdit, setEdit] = useState(false);
  const [miscellaneousInfo, setMiscellaneousInfo] = useState({});
  const [pltConstants, setPltConstants] = useState([]);
  useEffect(() => {
    getMiscellaneousInfo('skeletonLoader');
    globalPostService('console/get-constants/', { constant_types: ['config_install'] })
      .then(response => {
        if (checkApiStatus(response)) {
          setPltConstants(response.data.data)
        }
      })
  }, []);
  const getMiscellaneousInfo = (loaderType) => {
    loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
    globalGetService(`console/v2/${params.type}/${params.aircraft_slug}/miscellaneous/`)
      .then(response => {
        if (checkApiStatus(response)) {
          setMiscellaneousInfo(response.data.data);
        }
        loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
      })
  }
  const onFieldChange = (key, value) => {
    setMiscellaneousInfo({ ...miscellaneousInfo, [key]: value });
  }
  const onEditMiscellaneousInfo = () => {
    setLoading(true);
    let payload = Object.assign({}, miscellaneousInfo)
    globalPutService(`console/v2/${params.type}/${params.aircraft_slug}/miscellaneous/`, payload)
      .then(response => {
        if (checkApiStatus(response)) {
          enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
          getMiscellaneousInfo('pageloader')
          trackActivity('Console Management', {data:JSON.stringify(payload),  page_title: 'Miscellaneous(Titan Aviation)', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited Miscellaneous Details data from Edit Miscellaneous Details form' });
          setEdit(false);
        }
        setLoading(false);
      })
  }
  return (
    <div style={{ position: 'relative' }}>
      <div className="console-forms-fields" style={{ height: `${(window.innerHeight - (isEdit ? 260 : 215)) - navTitleOffset}px`, padding: '10px', overflow: 'auto' }}>
        <p style={{ textAlign: 'right', height: '20px' }}>
          {checkPermission('technical_specs', getPermissionKey(params.type), 'U') && !isEdit ?
            <span style={{ cursor: 'pointer' }}>
              <EditIcon onClick={() => { setEdit(true); }} fontSize="small" color='primary' />
            </span> : null
          }
        </p>
        {skeletonLoader ? < STableLoader count={3} size={7} /> : <>
          <Grid container spacing={1}>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='cargo_compartment_fire_compliance'
                label='Cargo Compartment – Fire Compliance'
                value={miscellaneousInfo?.cargo_compartment_fire_compliance || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('cargo_compartment_fire_compliance', e.target.value)}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              {(() => {
                return (
                  <Autocomplete
                    disabled={!isEdit}
                    options={pltConstants.filter(optionItem => optionItem.type === 'config_install')}
                    getOptionLabel={option => option?.label}
                    name="airstair"
                    value={miscellaneousInfo?.airstair || ''}
                    onChange={(e, value) => { onFieldChange('airstair', value); }}
                    renderInput={params => <TextField {...params} label="Airstair" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />} />
                )
              })()}
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='door_configuration'
                label='Door Configuration'
                value={miscellaneousInfo?.door_configuration || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('door_configuration', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='landing_capability'
                label='Landing Capability Current'
                value={miscellaneousInfo?.landing_capability || ''}
                fullWidth
                inputProps={{ maxLength: 255 }}
                margin="normal"
                onChange={(e) => onFieldChange('landing_capability', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='autoland_capabilities_limitation'
                label='Autoland Capabilities Limitation'
                value={miscellaneousInfo?.autoland_capabilities_limitation || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('autoland_capabilities_limitation', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='etops_current_config_capacity_cmp_revision'
                label='ETOPS Current Config Capacity'
                value={miscellaneousInfo?.etops_current_config_capacity_cmp_revision || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('etops_current_config_capacity_cmp_revision', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='etops_operational_standard'
                label='ETOPS Operational Standard'
                value={miscellaneousInfo?.etops_operational_standard || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('etops_operational_standard', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='act_provisions'
                label='ACT Provisions'
                value={miscellaneousInfo?.act_provisions || ''}
                fullWidth
                inputProps={{ maxLength: 255 }}
                margin="normal"
                onChange={(e) => onFieldChange('act_provisions', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              <TextField
                disabled={!isEdit}
                name='etops'
                label='ETOPS (Extended Range Twin Engine Operations)'
                value={miscellaneousInfo?.etops || ''}
                fullWidth
                margin="normal"
                inputProps={{ maxLength: 255 }}
                onChange={(e) => onFieldChange('etops', e.target.value.trimStart())}
                InputLabelProps={{ shrink: true }}
                variant='outlined'
              />
            </Grid>
            <Grid item md={4}>
              {(() => {
                let options = ['FAA', 'EASA'];
                return (
                  <Autocomplete
                    disabled={!isEdit}
                    options={options}
                    getOptionLabel={option => option}
                    name="afm_approval"
                    value={miscellaneousInfo?.afm_approval || ''}
                    onChange={(e, value) => { onFieldChange('afm_approval', value); }}
                    renderInput={params => <TextField {...params} label="AFM Approval " margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                  />
                )
              })()}
            </Grid>
          </Grid>
        </>}
      </div>
      {isEdit ?
        <Paper square style={{ padding: '10px', borderTop: '1px solid #d7d7d7' }}>
          <ul className="list-inline">
            <li className="list-inline-item">
              <Button onClick={() => { setEdit(false); getMiscellaneousInfo() }} color="primary" size='small' variant="outlined">Cancel</Button>
            </li>
            <li className="list-inline-item">
              <Button onClick={onEditMiscellaneousInfo} color="primary" size='small' variant="contained">SAVE</Button>
            </li>
          </ul>
        </Paper> : null
      }
      {isLoading ? <PageLoader /> : null}
    </div>
  )
}
export default withRouter(TAMiscellaneous);